/**
 * A board row's four plan cells — Today's list · List group · Progress ·
 * State — while the day plan has not answered (23/10/2026): shimmer
 * placeholders shaped like what is coming; "—" and "unknown" when it failed.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Badge, Skeleton } from '@/components/ui';

import type { BoardPreviewState } from './board-preview-state';

const DASH = <span className="text-xs text-muted-foreground">—</span>;

export const PendingCells: FC<{ state: Exclude<BoardPreviewState, 'ready'> }> = ({ state }) =>
  state === 'failed' ? (
    <>
      {DASH}
      {DASH}
      {DASH}
      <span title="Today's plan did not load — Retry above the rows">
        <Badge tone="secondary">unknown</Badge>
      </span>
    </>
  ) : (
    <>
      <span className="flex min-w-0 flex-col gap-1.5" data-testid="pending-cell">
        <Skeleton className="h-3 w-[70%] max-w-[190px]" />
      </span>
      <span className="flex min-w-0" data-testid="pending-cell">
        <Skeleton className="h-5 w-28 rounded-full" />
      </span>
      <span className="flex min-w-0" data-testid="pending-cell">
        <Skeleton className="h-3 w-16" />
      </span>
      <span className="flex min-w-0" data-testid="pending-cell">
        <Skeleton className="h-5 w-24 rounded-full" />
      </span>
    </>
  );
